import moment from "moment";
import { NycbsPharmaOrderDataModel } from "../data-model/tablesData";
import { NycbsPharmaOrderKeys } from "../enums/nycbsPharmaOrder";
import { NycbsStatus } from "../enums/nycbsStatus";
import { NycbsPharmaOrderDataKeys } from "../enums/tableColumnKeys";
import { logDataToConsole } from "./customLogger";
import { generateFullName } from "./generateOrderDataForTable";
import { capitalizeWordsSeparatedBySpace } from "./stringModifications";

export const generateTableDataForNycbsPharma = (
  data,
  providerDetails,
): NycbsPharmaOrderDataModel[] => {
  logDataToConsole("providerDetails", providerDetails);
  return data.map((order) => {
    const getStatus = () => {
      const assigneeId = order[NycbsPharmaOrderKeys?.AssigneeId] ?? "";
      const status = order[NycbsPharmaOrderKeys?.Status] ?? "";
      if (!assigneeId) {
        return NycbsStatus.UNASSIGNED;
      } else if (!status) {
        return NycbsStatus.MARK_AS_COMPLETED;
      } else {
        return Number(status);
      }
    };
    const getAssigneeName = () => {
      const assigneeId = order[NycbsPharmaOrderKeys?.AssigneeId] ?? "";
      if (!assigneeId) {
        return "";
      } else {
        const provider = providerDetails.find(
          (provider) => provider.id === assigneeId,
        );
        return provider
          ? generateFullName(provider.FirstName, "", provider.LastName)
          : "Unknown";
      }
    };
    return {
      [NycbsPharmaOrderDataKeys.PATIENT_DETAILS]: {
        mainText: capitalizeWordsSeparatedBySpace(
          generateFullName(
            order[NycbsPharmaOrderKeys?.PatientFirstName] ?? "",
            "",
            order[NycbsPharmaOrderKeys?.PatientLastName] ?? "",
          ),
        ),
        secondaryText:
          "MRN : " + (order[NycbsPharmaOrderKeys?.PatientMrn] ?? ""),
      },
      [NycbsPharmaOrderDataKeys.DATE_OF_BIRTH]:
        order[NycbsPharmaOrderKeys?.PatientDob] ?? "",
      [NycbsPharmaOrderDataKeys.MEDICATION]:
        order[NycbsPharmaOrderKeys?.DrugName] ?? "",
      [NycbsPharmaOrderDataKeys.PROVIDER_DETAILS]: generateFullName(
        order[NycbsPharmaOrderKeys?.ProviderFirstName] ?? "",
        "",
        order[NycbsPharmaOrderKeys?.ProviderLastName] ?? "",
      ),

      [NycbsPharmaOrderDataKeys.DATE_OF_SERVICE]: order[
        NycbsPharmaOrderKeys?.CreatedAt
      ]
        ? moment(order[NycbsPharmaOrderKeys?.CreatedAt]).format("MM/DD/YYYY")
        : "--",
      //TODO : Extract the logic for assignee
      [NycbsPharmaOrderDataKeys.ASSIGNEE]: {
        id: order[NycbsPharmaOrderKeys?.Identifier] ?? "",
        assignee: getAssigneeName(),
        assigneeId: order[NycbsPharmaOrderKeys?.AssigneeId] ?? "",
      },
      [NycbsPharmaOrderDataKeys.KEY]:
        order[NycbsPharmaOrderKeys?.CmmResultKey] ?? "",
      // TODO : Extract the logic for status
      [NycbsPharmaOrderDataKeys.STATUS]: {
        id: order[NycbsPharmaOrderKeys?.Identifier] ?? "",
        status: getStatus(),
      },
    };
  });
};
